module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "hhref": ""
    }
  }, [_vm._v("Edit List: " + _vm._s(_vm.$store.state.lists.thislist.name) + _vm._s(_vm.$store.state.lists.thislist.description ? ' (' + _vm.$store.state.lists.thislist.description + ')' : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('button', {
    staticClass: "btn btn-default navbar-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.BulkExport()
      }
    }
  }, [_vm._v("Bulk Export")])]), _vm._v(" "), _c('li', [_vm._v(" ")]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-warning navbar-btn",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#bulkModal"
    }
  }, [_vm._v("Bulk Actions")])]), _vm._v(" "), _c('li', [_vm._v(" ")]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-info navbar-btn",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#addModal"
    }
  }, [_vm._v("Add Entry")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bulkModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bulk List Actions")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkurls),
      expression: "bulkurls"
    }],
    attrs: {
      "id": "textarea_bulk_import",
      "name": "bulkurls",
      "cols": "78",
      "rows": "20",
      "placeholder": "Paste a list of Domains/URLs here, one per line.\n\nNB: Any https URLs will be blocked as full domains."
    },
    domProps: {
      "value": (_vm.bulkurls)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bulkurls = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errBulkmsg) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "float": "left"
    }
  }, [_vm._v("ERROR: " + _vm._s(_vm.errBulkmsg))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(!_vm.bulkprocessing) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "ddata-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.BulkProcess('add')
      }
    }
  }, [_vm._v("Add Items")]) : _vm._e(), _vm._v(" "), (!_vm.bulkprocessing) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "ddata-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.BulkProcess('replace')
      }
    }
  }, [_vm._v("Replace All")]) : _vm._e(), _vm._v(" "), (!_vm.bulkprocessing) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "ddata-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.BulkProcess('delete')
      }
    }
  }, [_vm._v("Delete Items")]) : _vm._e(), _vm._v(" "), (!_vm.bulkprocessing) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.BulkCancel()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.bulkprocessing) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.BulkCancel()
      }
    }
  }, [_vm._v("Please wait...")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    class: { in: _vm.addModalShown
    },
    attrs: {
      "id": "addModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Single URL Import")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("@")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oneurl),
      expression: "oneurl"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "oneurl",
      "type": "text",
      "placeholder": "https://xyz.com/abc"
    },
    domProps: {
      "value": (_vm.oneurl)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.ImportOneURL()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oneurl = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.errOnemsg) ? _c('span', {
    staticStyle: {
      "color": "red",
      "float": "left"
    }
  }, [_vm._v("ERROR: " + _vm._s(_vm.errOnemsg))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "ddata-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.ImportOneURL()
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Protocol")]), _vm._v(" "), _c('th', [_vm._v("Domain")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.state.lists.listentries), function(thisentry, thisindex) {
    return _c('tr', {
      class: {
        'highlightentry': _vm.highlight_id == thisentry.url_id
      }
    }, [_c('td', {
      staticClass: "col-sm-3",
      staticStyle: {
        "vertical-align": "middle",
        "padding": "4px"
      },
      attrs: {
        "align": "left"
      }
    }, [(thisentry.path == '/' || thisentry.path == '') ? _c('span', [_vm._v("http:// + https://")]) : _vm._e(), _vm._v(" "), (thisentry.path != '/' && thisentry.path != '') ? _c('span', [_vm._v("http://")]) : _vm._e(), _vm._v(" "), (_vm.rerenderCount) ? _c('span') : _vm._e()]), _vm._v(" "), (_vm.editing[thisindex]) ? _c('td', {
      staticClass: "col-sm-6",
      staticStyle: {
        "vertical-align": "middle",
        "padding": "4px"
      }
    }, [_c('form', {
      attrs: {
        "role": "form",
        "autocomplete": "off"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.onSubmit(thisentry)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "ref",
        rawName: "v-ref",
        value: ('domain' + thisindex),
        expression: "'domain' + thisindex"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "fields",
        "type": "text",
        "placeholder": "eg: domain.com"
      },
      domProps: {
        "value": thisentry.domain
      }
    })])]) : _vm._e(), _vm._v(" "), (!_vm.editing[thisindex]) ? _c('td', {
      staticClass: "col-sm-6",
      staticStyle: {
        "vertical-align": "middle",
        "padding": "4px"
      }
    }, [_vm._v("\n                " + _vm._s(thisentry.domain) + _vm._s(thisentry.path) + " "), (false) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("Domain")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      staticStyle: {
        "padding": "4px"
      },
      attrs: {
        "vv-if": "!thisentry.tmp_editing"
      }
    }, [(_vm.editing[thisindex]) ? _c('button', {
      staticClass: "btn btn-default btn-xs btn-edit",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.clickokdomain(thisindex, thisentry)
        }
      }
    }, [_vm._v("OK")]) : _vm._e(), _vm._v(" "), (_vm.editing[thisindex]) ? _c('button', {
      staticClass: "btn btn-default btn-xs btn-delete",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.clickcanceldomain(thisindex)
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (false && !_vm.editing[thisindex]) ? _c('button', {
      staticClass: "btn btn-default btn-xs btn-edit",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.clickeditdomain(thisindex)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (!_vm.editing[thisindex]) ? _c('button', {
      staticClass: "btn btn-default btn-xs btn-delete",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.clickdeletedomain(thisentry)
        }
      }
    }, [_vm._v("Delete")]) : _vm._e()])])
  })), _vm._v(" "), _c('tfoot', [_c('td')])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('nav', {
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination",
    staticStyle: {
      "margin": "4px"
    }
  }, [_c('li', {
    class: {
      'disabled': (_vm.$store.state.lists.listentries_pageinfo.thispage_number == 1)
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.page - _vm.pageSkip)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _vm._l((_vm.$store.state.lists.listentries_pageinfo.display_pagelist), function(pageentry, pageindex) {
    return _c('li', {
      class: {
        'active': (pageentry == _vm.$store.state.lists.listentries_pageinfo.thispage_number)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setPage(pageentry)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(pageentry))])])
  }), _vm._v(" "), _c('li', {
    class: {
      'disabled': (_vm.$store.state.lists.listentries_pageinfo.thispage_number >= _vm.$store.state.lists.listentries_pageinfo.total_pages)
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.page + _vm.pageSkip)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])], 2)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50084508"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/lists/edit/index.vue
// module id = 223
// module chunks = 1